import * as React from 'react'
import { StyleSheet, View } from 'react-native'
import { SolitoImage } from 'solito/image'
import { Link } from 'solito/link'
import { Card, Title, Footer } from '@components/Card'
import ClockTag from './ClockTag'
import type { Story } from '../model/story'

export function StoryListItem(
  props: Pick<Story, 'id' | 'title' | 'published_date' | 'hero_image_path'>
) {
  const publishedDate = new Date(props.published_date)

  return (
    <View style={{ paddingHorizontal: 16 }}>
      <Link href={`/story/${props.id}`}>
        <Card type="story">
          <View style={styles.imageContainer}>
            <SolitoImage
              alt={props.title}
              contentFit="cover"
              style={styles.image}
              src={props.hero_image_path}
              fill={true}
            />
          </View>
          <View style={styles.cardContent}>
            <Title text={props.title} />
            <Footer>
              <ClockTag date={publishedDate} />
            </Footer>
          </View>
        </Card>
      </Link>
    </View>
  )
}

const styles = StyleSheet.create({
  image: {},
  imageContainer: {
    width: '100%',
    // height: 220,
    aspectRatio: 5 / 3,
    overflow: 'hidden',
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  cardContent: {
    marginVertical: 13,
    marginHorizontal: 16,
  },
})
